import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { retry, catchError, switchMap, filter, take } from 'rxjs/operators';
import { LoaderService } from '../services/loader.service';
import { NotificationService } from '../services/notification.service';
import { User } from '../models/user';
import { SessionStorageService } from '../services/session-storage.service';
import { AuthService } from '../services/auth.service';

export class HttpErrorInterceptor implements HttpInterceptor {
  private AUTH_HEADER = 'Authorization';
  private CONTENT = 'X-Content-Type-Options';
  private token = '';
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );
  constructor(
    protected _notificationSvc: NotificationService,
    protected loaderSvc: LoaderService,
    private localService: SessionStorageService,
    private authService: AuthService
  ) {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // if (!request.headers.has("Content-Type")) {
    //   request = request.clone({
    //     headers: request.headers.set("Content-Type", "application/json"),
    //   });
    // }
    if (!request.headers.has('Content-Type')) {
      // request = request.clone({
      //   headers: request.headers.set(this.CONTENT, "nosniff"),
      // });
      // request = request.clone({
      //   headers: request.headers.set("X-FRAME-OPTIONS", "SAMEORIGIN"),
      // });
      request = request.clone({
        headers: request.headers.set('Accept', 'application/json '),
      });

      // request = request.clone({
      //   headers: request.headers.set(
      //     "Content-Type",
      //     "application/json ; charset=utf-8"
      //   ),
      // });
    }
    request = this.addAuthenticationToken(request);
    return next.handle(request).pipe(
      retry(1),
      catchError((error: HttpErrorResponse) => {
        this.loaderSvc.hide();
        if (
          error instanceof HttpErrorResponse &&
          error.status == 401 &&
          !request.url.includes('/api/v1/signin')
        ) {
          return this.handle401Error(request, next);
        } else if (
          error instanceof HttpErrorResponse &&
          error.status == 403 &&
          !request.url.includes('/api/v1/signin')
        ) {
          this.authService.logout();
        }

        let errorMessage = 'Something went wrong, please try again !';
        // if (error.error instanceof ErrorEvent) {
        if (error.error && error.error.message) {
          // client-side error
          errorMessage = `Error: ${error.error.message}`;
        } else {
          // server-side error
          // errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        this._notificationSvc.error('Error', errorMessage);
        return throwError(errorMessage);
      })
    );
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);
      const user: any = this.localService.getItem<User>('user');
      this.token = user;
      if (this.token)
        return this.authService.refreshToken(this.token).pipe(
          switchMap((token: any) => {
            this.isRefreshing = false;
            this.authService.setCurrentUser(token);
            this.refreshTokenSubject.next(token.accessToken);
            return next.handle(this.addAuthenticationToken(request));
          }),
          catchError((err) => {
            return throwError(err);
          })
        );
    }
    return this.refreshTokenSubject.pipe(
      filter((token) => token !== null),
      take(1),
      switchMap((token) => next.handle(this.addAuthenticationToken(request)))
    );
  }

  private addAuthenticationToken(request: HttpRequest<any>): HttpRequest<any> {
    const user: any = this.localService.getItem<User>('user');
    // this.token = user && user.accessToken;
    // If we do not have a token yet then we should not set the header.
    // Here we could first retrieve the token from where we store it.
    if (!this.token) {
      return request;
    }
    // If you are calling an outside domain then do not add the token.
    // if (!request.url.match(/www.mydomain.com\//)) {
    //   return request;
    // }
    return request.clone({
      headers: request.headers.set(
        this.AUTH_HEADER,
        `${(user && user.tokenType) || 'Bearer'} ` + this.token
      ),
    });
  }
}
